var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.routerLink)?_c('router-link',{attrs:{"to":_vm.routerLink,"target":_vm.targetBlank ? '_blank' : '_self'}},[_c('v-btn',{attrs:{"text":"","link":"","small":""}},[_vm._v(_vm._s(_vm.label))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }